import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Dimmer, Grid, Header, Loader } from 'semantic-ui-react';
import { Push, push } from 'connected-react-router';
import { IProject, IPtw, statusMap } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { projectAction, ptwAction } from '../redux/actions';
import { appState } from '../redux/selectors';
import { PtwDetailComponent } from '../components/ptw/PtwDetailComponent';
import { PtwDetailNextComponent } from '../components/ptw/PtwDetailNextComponent';
import { RootState } from '../redux/types';
import { TranslationComponent } from '../components/TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

interface PtwDetailSceneProps extends Component {
  i18n: typeof i18n;
  t: typeof i18n.t;
  push: Push;
  projectId: string;
  ptwId: string;
  project: IProject;
  ptw: IPtw;
  projectAction: typeof projectAction;
  ptwAction: typeof ptwAction;
}

class PPtwDetailScene extends Component<PtwDetailSceneProps> {
  componentDidMount(): void {
    const { projectId, ptwId, projectAction, ptwAction } = this.props;
    projectAction(projectId);
    ptwAction(ptwId);
  }

  render() {
    const { push, project, ptw, projectId, ptwId } = this.props;

    if (!project || !ptw) {
      return (
        <Dimmer active inverted>
          <Loader inverted>
            <TranslationComponent stringKey={'Loading'} />
          </Loader>
        </Dimmer>
      );
    }

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <Grid style={{ marginBottom: '20px' }}>
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Header>
                  <TranslationComponent
                    stringKey={'{{name}} - {{name_2}} - PTW #{{sequentialNumber}} | {{name_3}}'}
                    values={{
                      name: project.name,
                      name_2: ptw.name,
                      sequentialNumber: ptw.sequentialNumber,
                      name_3: statusMap[ptw.status].name,
                    }}
                  />
                </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column floated="left" width={2} textAlign="center">
                <Button primary onClick={() => push('./')}>
                  <TranslationComponent stringKey={'Back'} />
                </Button>
              </Grid.Column>
              <Grid.Column floated="right" width={8}>
                <Container style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <PtwDetailNextComponent project={project} ptw={ptw} />
                </Container>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <PtwDetailComponent projectId={projectId} ptwId={ptwId} />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: any) => ({
  projectId: ownProps.match.params.projectId,
  ptwId: ownProps.match.params.ptwId,
  project: appState(state).project,
  ptw: appState(state).ptw,
});

export const PtwDetailScene = connect(mapStateToProps, { push, projectAction, ptwAction })(
  withTranslation()(PPtwDetailScene)
);
